import React, { useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';

export default function PayoutRecipientConfirmationModal({
  isOpen,
  recipientName,
  destination,
  amount,
  onConfirm,
  onCancel,
}) {
  const [isProcessing, setIsProcessing] = useState(false);
  const isVerified = recipientName != null;

  async function handleConfirm() {
    setIsProcessing(true);
    try {
      await onConfirm();
    } finally {
      setIsProcessing(false);
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={onCancel}
      centered
      backdrop={isProcessing ? 'static' : true}
      keyboard={!isProcessing}
    >
      <Modal.Header closeButton={!isProcessing}>
        <Modal.Title>Confirm Payment</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="mb-3">
          You are about to send <strong>KES {amount}</strong> to <strong>{destination}</strong>.
        </p>

        {isVerified ? (
          <div className="alert alert-success py-2 mb-0">
            <div className="d-flex align-items-center mb-2">
              <i className="bi bi-check-circle-fill me-2" />
              <span className="fw-semibold">Verified M-Pesa recipient</span>
            </div>
            <div className="mb-2">{recipientName}</div>
            <small>Please confirm this is the correct recipient before proceeding.</small>
          </div>
        ) : (
          <div className="alert alert-warning py-2 mb-0">
            <div className="d-flex align-items-center mb-2">
              <i className="bi bi-exclamation-triangle-fill me-2" />
              <span className="fw-semibold">No verified name on record</span>
            </div>
            <small>
              Please double-check the recipient details above. Reversal of a sent payment is
              possible but not guaranteed.
            </small>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel} disabled={isProcessing}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleConfirm} disabled={isProcessing}>
          {isProcessing ? (
            <>
              <Spinner as="span" animation="border" size="sm" className="me-2" role="status" aria-hidden="true" />
              Processing...
            </>
          ) : (
            'Confirm & Send'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
